export default __webpack_public_path__ + "static/media/pdt.37b233fe.PNG";